import request from './request';

const bonusService = {
  listRules: (params) =>
    request.get('dashboard/admin/bonuses/list', { params }),
  createRule: (payload) =>
    request.post('dashboard/admin/bonuses/list', payload),
  updateRule: (id, payload) =>
    request.put(`dashboard/admin/bonuses/update/${id}`, payload),
  approveRule: (id, body) => {
    const url = `dashboard/admin/bonuses/${id}/approve`;
    if (body != null && typeof body === 'object' && Object.keys(body).length > 0) {
      return request.post(url, body);
    }
    return request.post(url);
  },
  deleteOne: (id) => request.delete(`dashboard/admin/bonuses/${id}`),
  deleteBulk: (ids) =>
    request.delete('dashboard/admin/bonuses/delete', { data: { ids } }),
};

export default bonusService;
